(() => {
  'use strict';

  const CARD_SELECTOR = '.product-card-wrapper';
  const BUTTON_SELECTOR = '[data-ticho-variant-preview]';

  function imageNodes(card) {
    return Array.from(card.querySelectorAll('.ticho-card-image img'));
  }

  function activeImageNodes(card) {
    const theme = document.documentElement.dataset.tichoTheme === 'evening' ? 'evening' : 'day';
    const themed = card.querySelector(`.ticho-card-image__${theme}`);
    return themed ? [themed] : imageNodes(card).slice(0, 1);
  }

  function rememberOriginal(img) {
    if (img.dataset.tichoOriginalRemembered === 'true') return;
    img.dataset.tichoOriginalRemembered = 'true';
    img.dataset.tichoOriginalSrc = img.getAttribute('src') || '';
    img.dataset.tichoOriginalSrcset = img.getAttribute('srcset') || '';
    img.dataset.tichoOriginalAlt = img.getAttribute('alt') || '';
  }

  function applyPreview(card, button) {
    const src = button.dataset.imageSrc;
    const srcset = button.dataset.imageSrcset;
    const alt = button.dataset.imageAlt || '';
    if (!src) return;

    const wrapper = card.querySelector('.ticho-card-image');
    if (wrapper) wrapper.classList.add('is-variant-preview');

    activeImageNodes(card).forEach((img) => {
      rememberOriginal(img);
      img.src = src;
      if (srcset) img.srcset = srcset;
      img.alt = alt;
    });
  }

  function restoreOriginal(card) {
    const selected = card.querySelector(`${BUTTON_SELECTOR}.is-selected`);
    if (selected && selected.dataset.tichoLocked === 'true') {
      applyPreview(card, selected);
      return;
    }

    const wrapper = card.querySelector('.ticho-card-image');
    if (wrapper) wrapper.classList.remove('is-variant-preview');

    imageNodes(card).forEach((img) => {
      rememberOriginal(img);
      img.src = img.dataset.tichoOriginalSrc || img.src;
      const originalSrcset = img.dataset.tichoOriginalSrcset || '';
      if (originalSrcset) img.srcset = originalSrcset;
      else img.removeAttribute('srcset');
      img.alt = img.dataset.tichoOriginalAlt || '';
    });
  }

  function updateCardLinks(card, url) {
    if (!url) return;
    card.querySelectorAll('a.full-unstyled-link, a[data-ticho-variant-link]').forEach((link) => {
      link.href = url;
    });
  }

  function updateSelectedLabel(card, button) {
    const label = card.querySelector('[data-ticho-selected-variant-label]');
    if (label) label.textContent = button.dataset.variantLabel || '';
  }

  function updateQuickAdd(card, button) {
    const input = card.querySelector('[data-ticho-card-variant-input]');
    const submit = card.querySelector('.ticho-card-quick-add__button');
    const label = card.querySelector('[data-ticho-quick-add-label]');
    if (input) input.value = button.dataset.variantId || input.value;

    if (!submit || submit.tagName === 'A') return;
    const available = button.dataset.variantAvailable !== 'false';
    submit.disabled = !available;
    if (label) label.textContent = available ? 'Dodaj do koszyka' : 'Niedostępny';
  }

  function updateDisplayedPrice(card, button) {
    const formatted = button.dataset.variantPrice;
    if (!formatted) return;
    const regular = card.querySelector('.price-item--regular');
    const sale = card.querySelector('.price-item--sale');
    if (sale && sale.offsetParent !== null) sale.textContent = formatted;
    else if (regular) regular.textContent = formatted;
    const start10 = card.querySelector('[data-ticho-start10-price]');
    if (start10 && button.dataset.variantStart10Price) {
      start10.textContent = button.dataset.variantStart10Price;
    }
  }

  function selectVariant(card, button) {
    card.querySelectorAll(BUTTON_SELECTOR).forEach((node) => {
      const selected = node === button;
      node.classList.toggle('is-selected', selected);
      node.dataset.tichoLocked = selected ? 'true' : 'false';
      node.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
    applyPreview(card, button);
    updateCardLinks(card, button.dataset.variantUrl);
    updateSelectedLabel(card, button);
    updateQuickAdd(card, button);
    updateDisplayedPrice(card, button);
  }

  function initializeCard(card) {
    const selected = card.querySelector(`${BUTTON_SELECTOR}.is-selected`);
    if (!selected) return;
    selected.dataset.tichoLocked = 'false';
    updateSelectedLabel(card, selected);
    updateQuickAdd(card, selected);
  }

  document.addEventListener('pointerover', (event) => {
    if (!window.matchMedia('(hover: hover)').matches) return;
    const button = event.target.closest(BUTTON_SELECTOR);
    if (!button) return;
    const card = button.closest(CARD_SELECTOR);
    if (card) applyPreview(card, button);
  });

  document.addEventListener('pointerout', (event) => {
    if (!window.matchMedia('(hover: hover)').matches) return;
    const button = event.target.closest(BUTTON_SELECTOR);
    if (!button) return;
    if (button.contains(event.relatedTarget)) return;
    const card = button.closest(CARD_SELECTOR);
    if (card) restoreOriginal(card);
  });

  document.addEventListener('focusin', (event) => {
    const button = event.target.closest(BUTTON_SELECTOR);
    if (!button) return;
    const card = button.closest(CARD_SELECTOR);
    if (card) applyPreview(card, button);
  });

  document.addEventListener('focusout', (event) => {
    const button = event.target.closest(BUTTON_SELECTOR);
    if (!button) return;
    const card = button.closest(CARD_SELECTOR);
    if (card) restoreOriginal(card);
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest(BUTTON_SELECTOR);
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    const card = button.closest(CARD_SELECTOR);
    if (card) selectVariant(card, button);
  });

  // Swatch thumbnails are CSS backgrounds, which native lazy-loading doesn't
  // cover: on the homepage dozens of them used to download together with the
  // hero. Set each one only when its card is ~300px from the viewport.
  const SWATCH_SELECTOR = '[data-ticho-swatch-image]';
  const showSwatches = (root) => {
    root.querySelectorAll(SWATCH_SELECTOR).forEach((swatch) => {
      swatch.style.setProperty('--ticho-swatch-image', `url('${swatch.dataset.tichoSwatchImage}')`);
      swatch.removeAttribute('data-ticho-swatch-image');
    });
  };
  const swatchObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          showSwatches(entry.target);
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '300px' })
    : null;
  const watchSwatches = (root) => {
    root.querySelectorAll('[data-ticho-card-variants]').forEach((group) => {
      if (!group.querySelector(SWATCH_SELECTOR)) return;
      if (swatchObserver) swatchObserver.observe(group);
      else showSwatches(group);
    });
  };

  function initAll() {
    document.querySelectorAll(CARD_SELECTOR).forEach(initializeCard);
    watchSwatches(document);
  }

  // Cards re-rendered by filters, sorting or cart updates.
  if ('MutationObserver' in window) {
    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) watchSwatches(node);
      }));
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('ticho:themechange', () => {
    document.querySelectorAll(CARD_SELECTOR).forEach((card) => {
      const selected = card.querySelector(`${BUTTON_SELECTOR}.is-selected[data-ticho-locked="true"]`);
      if (selected) applyPreview(card, selected);
    });
  });
})();
